import axios from "axios";

export default async function encode(data: any) {
    try {
        const res = await axios.post("/api/encode", data);
        return res.data?.status === 200 ? res.data?.data : null;
    } catch (error) {
        console.log("🚀 ~ encode ~ error:", error);
        return null;
    }
}
